<template>
  <v-main class="fill-height pa-2 idcs-main-list">
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent relative"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab bottom absolute @click="edit({status:1,rules:{}})" dark class="pink ml-4">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.cmsuser">
            <template #idx>
              <span>{{item.idx}}</span>
            </template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="user_errors"
              :label="$t('fields.name')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
            <v-text-field
              v-model="newpass"
              :label="$t('fields.newpass')"
              append-icon="mdi-dice-multiple-outline"
              @click:append="generatePass"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm=true" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{$t("dialog.txt.delUser")}}</ConfirmDialog>
  </v-main>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import passUtils from "@/password.js";

export default {
  name: "Users",
  mixins: [commonmixin],
  data() {
    return {
      user_errors: "",
      newpass: "",
      d_edit: false,
      item: {
        rules: {},
      },
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 100,
        },
        {
          text: this.$t("fields.name"),
          value: "name",
        },
        {
          text: this.$t("fields.created"),
          value: "created",
        },
        {
          text: this.$t("fields.updated"),
          value: "updated",
        },
        {
          text: this.$t("fields.status"),
          value: "status",
        },
      ],
    };
  },
  methods: {
    generatePass() {
      this.newpass = passUtils.generate(10);
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.users.indexOf(i);
      this.newpass = "";
      this.item.pass = "";
    },
    remove() {
      if (this.$store.getters["admin/isUsers"] == 1) {
        this.user_errors = this.$t("error.lastrec");
      } else {
        this.$store.dispatch("admin/DELETE_USER", this.item).then(() => {
          this.d_edit = false;
        });
      }
    },
    update() {
      if (this.newpass) {
        this.item.pass = this.$CryptoJS.enc.Base64.stringify(
          this.$CryptoJS.SHA256(this.newpass)
        );
      }

      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_USER", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.users.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.user_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_USER", this.item)
            .then((response) => {
              if (response == 0) {
                this.user_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  computed: {
    users() {
      return this.$store.getters["admin/users"];
    },
  },
  mounted() {
    if (!this.$store.getters["admin/isUsers"]) {
      this.$store.dispatch("admin/LOAD_USERS");
    }
  },
};
</script>

<style scoped>
.relative {
  position: relative;
}
</style>